import { render, staticRenderFns } from "./affirm.vue?vue&type=template&id=2dd79d40&scoped=true"
import script from "./affirm.vue?vue&type=script&lang=js"
export * from "./affirm.vue?vue&type=script&lang=js"
import style0 from "./affirm.vue?vue&type=style&index=0&id=2dd79d40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd79d40",
  null
  
)

export default component.exports